require('./blocks/page.index/page-index.less');
require('./blocks/page.index/socials-widget.less');
require('./blocks/benefits/benefits');
require('./blocks/benefit.less');
require('./blocks/fullwidth-slider/fullwidth-slider');
require('./blocks/index-block-catalog/index-block-catalog.less');
require('./blocks/index-block-action/index-block-action.less');
require('./blocks/index-block-brands/index-block-brands.less');
require('./blocks/index-block-center/index-block-center.less');
require('./blocks/index-block-news/index-block-news.less');
require('./blocks/index-block-reviews/index-block-reviews.less');
require('./blocks/index-block-subscribe-form/index-block-subscribe-form');



// WEBPACK FOOTER //
// ./index.js